// mds-dojo — FAITHFUL port of dojox/widget/_CalendarMonth (dojo 1.x). declare from declare-runtime;
// dojo/text!./Calendar/X.html → import ?raw. Upgrades the earlier deliberate STUB to a full port.
import declare from '../../dojo/_base/declare-runtime';
import _CalendarMonthView from './_CalendarMonthView';
export default declare("dojox.widget._CalendarMonth", null, {
		// summary:
		//		Mixin class for adding a view listing all 12 months of the year to the
		//		dojox/widget/_CalendarBase

		constructor: function(){
			// summary:
			//		Adds a dojox/widget/_CalendarMonthView view to the calendar widget.
			this._addView(_CalendarMonthView);
		}
	});
